import { Box } from "@chakra-ui/react";
import React from "react";

const Page: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Box
    flex={1}
    display="flex"
    flexDirection="column"
    overflow="hidden"
    bg="gray.50"
  >
    {children}
  </Box>
);

export default Page;
